import { addMonths, subMonths } from "date-fns";

const timeStringToMinutes = (timeString) => {
  const [hours, minutes] = timeString.split(":").map(Number);
  return hours * 60 + minutes;
};

export const convertPresetsToDb = (preset, isEdit = false) => {
  if (isEdit) {
    return preset.schedules.map((schedule) => ({
      type_id: preset.id,
      start_time: timeStringToMinutes(schedule.start),
      end_time: timeStringToMinutes(schedule.end),
      description: preset.description,
      type_name: preset.name,
    }));
  }
  return preset.schedules.map((schedule) => ({
    type_id: null,
    start_time: timeStringToMinutes(schedule.start),
    end_time: timeStringToMinutes(schedule.end),
    description: preset.description,
    type_name: preset.name,
  }));
};

export const generateCalendar = (date) => {
  const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  const startDate = new Date(firstDay);
  startDate.setDate(startDate.getDate() - firstDay.getDay());
  const calendar = [];
  const totalDays = 42;
  for (let i = 0; i < totalDays; i++) {
    const currentDate = new Date(startDate);
    currentDate.setDate(startDate.getDate() + i);
    calendar.push(currentDate);
  }
  return calendar;
};

export const formatYearMonth = (date) => {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
    2,
    "0"
  )}`;
};

export const getDateData = (date, calendarData) => {
  const dateString = `${date.getFullYear()}-${String(
    date.getMonth() + 1
  ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
  const machineData =
    calendarData?.data?.machineTimeData.filter(
      (item) => item.oper_date === dateString
    ) || [];
  const specData =
    calendarData?.data?.specTimeData.filter(
      (item) => item.oper_date === dateString
    ) || [];
  return { machineData, specData };
};

export const getPresetInfo = (typeId, presets) => {
  return presets?.find((p) => p.id === typeId);
};

export const getPresetName = (typeId, presets) => {
  const preset = presets?.find((p) => p.id === typeId);
  return preset?.name || "";
};

export const formatDate = (dateString) => {
  return dateString.split(" ")[0];
};

export const isConsecutiveDate = (date1, date2) => {
  const d1 = new Date(date1);
  const d2 = new Date(date2);
  const diffTime = Math.abs(d2 - d1);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays === 1;
};

export const groupSchedules = (schedules, presets) => {
  if (!schedules || !schedules.length) return [];
  // 오늘 날짜 기준 필터링 제거
  // const today = new Date();
  // today.setHours(0, 0, 0, 0);
  // const filteredSchedules = schedules.filter((schedule) => {
  //   const scheduleDate = new Date(schedule.oper_date);
  //   scheduleDate.setHours(0, 0, 0, 0);
  //   return scheduleDate >= today;
  // });
  // if (filteredSchedules.length === 0) return [];
  const sortedSchedules = [...schedules].sort(
    (a, b) => new Date(a.oper_date) - new Date(b.oper_date)
  );
  const groups = [];
  let currentGroup = {
    presetId: sortedSchedules[0].type_id,
    type_id: sortedSchedules[0].type_id,
    startDate: formatDate(sortedSchedules[0].oper_date),
    endDate: formatDate(sortedSchedules[0].oper_date),
    presetName:
      presets.find((p) => p.id === sortedSchedules[0].type_id)?.name ||
      `type_${sortedSchedules[0].type_id}`,
  };
  for (let i = 1; i < sortedSchedules.length; i++) {
    const currentSchedule = sortedSchedules[i];
    const prevSchedule = sortedSchedules[i - 1];
    if (
      currentSchedule.type_id === prevSchedule.type_id &&
      isConsecutiveDate(prevSchedule.oper_date, currentSchedule.oper_date)
    ) {
      currentGroup.endDate = formatDate(currentSchedule.oper_date);
    } else {
      groups.push({ ...currentGroup });
      currentGroup = {
        type_id: currentSchedule.type_id,
        startDate: formatDate(currentSchedule.oper_date),
        endDate: formatDate(currentSchedule.oper_date),
        presetName:
          presets.find((p) => p.id === currentSchedule.type_id)?.name ||
          `type_${currentSchedule.type_id}`,
      };
    }
  }
  groups.push(currentGroup);
  return groups;
};

export const formatDateString = (date) => {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(date.getDate()).padStart(2, "0")}`;
};

export const getMonthRange = (date) => {
  const prevMonth = subMonths(date, 1);
  const nextMonth = addMonths(date, 1);
  return {
    prevMonth: formatYearMonth(prevMonth),
    currentMonth: formatYearMonth(date),
    nextMonth: formatYearMonth(nextMonth),
  };
};

export const formatTimeString = (timeStr) => {
  if (!timeStr) return "09:00";
  const cleanTime = timeStr.trim();
  const timeFormat = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
  if (timeFormat.test(cleanTime)) {
    const [hours, minutes] = cleanTime.split(":");
    return `${hours.padStart(2, "0")}:${minutes}`;
  }
  return "09:00";
};

export const timeToMinutes = (str) => {
  const timeStr = str.split(" ")[1].substring(0, 5);
  const [hours, minutes] = timeStr.split(":").map(Number);
  return hours * 60 + minutes;
};

export const isTimeOverlapping = (schedules) => {
  if (!schedules || schedules.length < 1) return false;
  const convertTimeToMinutes = (timeStr, isUntilMidnight) => {
    const [hours, minutes] = timeStr.split(":").map(Number);
    return isUntilMidnight ? 24 * 60 : hours * 60 + minutes;
  };
  for (let schedule of schedules) {
    const startMinutes = convertTimeToMinutes(schedule.start, false);
    const endMinutes = convertTimeToMinutes(
      schedule.end,
      schedule.isUntilMidnight
    );
    if (startMinutes >= endMinutes) {
      return {
        isValid: false,
        message: `${schedule.start}~${
          schedule.isUntilMidnight ? "24:00" : schedule.end
        }: 종료 시간이 시작 시간보다 빠르거나 같습니다.`,
      };
    }
  }
  const sortedSchedules = [...schedules].sort((a, b) => {
    return (
      convertTimeToMinutes(a.start, false) -
      convertTimeToMinutes(b.start, false)
    );
  });
  for (let i = 0; i < sortedSchedules.length - 1; i++) {
    const currentEnd = convertTimeToMinutes(
      sortedSchedules[i].end,
      sortedSchedules[i].isUntilMidnight
    );
    const nextStart = convertTimeToMinutes(sortedSchedules[i + 1].start, false);
    if (currentEnd > nextStart) {
      return {
        isValid: false,
        message: `${sortedSchedules[i].start}~${
          sortedSchedules[i].isUntilMidnight ? "24:00" : sortedSchedules[i].end
        }와 ${sortedSchedules[i + 1].start}~${
          sortedSchedules[i + 1].isUntilMidnight
            ? "24:00"
            : sortedSchedules[i + 1].end
        } 시간이 겹칩니다.`,
      };
    }
  }
  return { isValid: true, message: "유효한 시간 설정입니다." };
};

export const formatTimeString2 = (time) => {
  if (!time) return "00:00";
  return time.padStart(5, "0");
};

export const handleAddSchedule = (target, setTarget) => {
  setTarget({
    ...target,
    schedules: [
      ...target.schedules,
      {
        id: Date.now(),
        start: "09:00",
        end: "18:00",
        isUntilMidnight: false,
      },
    ],
  });
};

export const isValidDateFormat = (dateString) => {
  const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;
  if (!dateFormatRegex.test(dateString)) return false;
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}` === dateString;
};
